import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useParams, useHistory } from "react-router-dom";
import { Tabs, Tab } from "react-bootstrap";
import Dropzone from "../common/DropzoneExample";
import { toastr } from "react-redux-toastr";
// import "react-toastrify/dist/Reacttoastrify.css";
import axios from "axios";
import {
	createdLeakedCodeRecord,
	createDarkWebRecord,
	createAppSToreRecord,
	createSocialMediaProfile,
	createPastbinSearch,
	createMalwareCredentials,
	createPii,
	createStolenCrdentials,
	createBrandMention,
	createCloudBucket,
} from "../../actions/leakedCode";
import {
	telegramPost,
	createManualLeakedSession,
	createPostmanRecord,
} from "../../actions/leakedCredentials";
import { createIpPorts } from "../../actions/inventory";
import { API_URL } from "../../utils/constant";
import { id } from "date-fns/locale";
// import {ex}

// Update the file URLs at the top
const fileUrls = {
	brandMentions: "/assets/excel/demo_brand_mentions_upload.xlsx",
	malwareCredentials: "/assets/excel/malware_credentials_demo.xlsx",
	socialMediaProfiles: "/assets/excel/demo-social-media-profiles.xlsx",
	stolenCredentials: "/assets/excel/demo-Stolen-cred-leaked-credentials.xlsx",
	leakedSession: "/assets/excel/demo-leaked-session.xlsx",
	piiDetails: "/assets/excel/demo_personal-info.xlsx",
	cloudBuckets: "/assets/excel/open_cloud_demo.xlsx",
	telegramMonitoring: "/assets/excel/telegram_bulk_upload_template.xlsx",
	darkwebForum: "/assets/excel/darkweb_bulk_upload_template.xlsx",
	MobileApp:"/assets/excel/demo-mobile-apps-delta-upload.xlsx",
};

var Model = require("./model");

const FeedInformation = () => {
	const dispatch = useDispatch();
	const { orgId } = useParams();
	const history = useHistory();
	const [appId, setAppId] = useState("");
	const [appName, setAppName] = useState("");
	const [appStoreUrl, setAppStoreUrl] = useState("");
	const [appStoreResource, setAppStoreResource] = useState("");
	const [appStoreSeverity, setAppStoreSeverity] = useState("");
	const [appSummary, setAppStoreSummary] = useState("");
	const [appStoreDetails, setAppStoreDetails] = useState("");
	const [appStoreAttachment, setAppStoreAttachment] = useState("");
	const [appStoreComments, setAppStoreComments] = useState("");
	const [appDeveloperWebsite, setAppDeveloperWebsite] = useState("");
	const [appDeveloperEmail, setAppDeveloperEmail] = useState("");
	const [resetDropzone, setResetDropzone] = useState(false);

	const [repoUrl, setRepoUrl] = useState("");
	const [programmingLanguage, setProgrammingLanguage] = useState("");
	const [severityLevel, setSourceCodeSeverity] = useState("");
	const [leakedCode, setLeakedCode] = useState("");
	const [comments, setSourceCodeComments] = useState("");
	const [attachmentUrl, setAttachmentUrl] = useState("");
	const [upload, setupload] = useState("");
	const [isSuspicious, setSourceCodeSuspicious] = useState("");

	const [fakePageUrl, setFakePageUrl] = useState("");
	const [socialMediaPlatform, setSocialMediaPlatform] = useState("");
	const [socialSeverity, setSocialSeverity] = useState("");
	const [socialComments, setSocialComments] = useState("");
	const [socialAttachment, setSocialAttachment] = useState("");

	const [darkWebUrl, setDarkWebUrl] = useState("");
	const [darkWebMentionType, setDarkWebMentionType] = useState("");
	const [darkWebSeverity, setDarkWebSeverity] = useState("");
	const [darkWebDetails, setDarkWebDetails] = useState("");
	const [darkWebComments, setDarkWebComments] = useState("");

	const [darkWebAttachmentUrl, setDarkWebAttachmentUrl] = useState("");
	const [titleDarkWeb, setTitleDarkWeb] = useState("");
	const [threadLinkDarkWeb, setThreadLinkDarkWeb] = useState("");
	const [authorNameDarkWeb, setAuthorNameDarkWeb] = useState("");
	const [authorUrlDarkWeb, setAuthorUrlDarkWeb] = useState("");
	const [sourceSourceDarkWeb, setSourceDarkWeb] = useState("");
	const [authorLinkDarkWeb, setAuthorLinkDarkWeb] = useState("");
	const [authorDarkWeb, setAuthorDarkWeb] = useState("");
	const [dateDarkWeb, setDateDarkWeb] = useState("");

	const [groupname, setGroupName] = useState("");
	const [message, setMessage] = useState("");
	const [telegramDate, setTelegramDate] = useState("");
	const [messagelink, setMessageLink] = useState("");
	const [telegramImg, setTelegramImg] = useState("");

	const [title, setTitle] = useState("");
	const [snippet, setSnippet] = useState("");
	const [date, setDate] = useState("");
	const [link, setLink] = useState("");
	const [pastebinAttachmentUrl, setPastebinAttachmentUrl] = useState("");
	const [resetPastebinDropzone, setResetPastebinDropzone] = useState(false);

	const [createdAt, setCreatedAt] = useState("");
	const [usr, setUsr] = useState("");
	const [src, setSrc] = useState("");
	const [mal, setMal] = useState("");
	const [pwd, setPwd] = useState("");
	const [iip, setIip] = useState("");
	const [hid, setHid] = useState("");
	const [fnd, setFnd] = useState("");

	const [email, setEmail] = useState("");
	const [ip_address, setIp_address] = useState("");
	const [username, setUsername] = useState("");
	const [address, setAddress] = useState("");
	const [phone, setPhone] = useState("");
	const [database_name, setDatabase_name] = useState("");
	const [createdAtDate, setCreatedAtDate] = useState("");

	const [eml, setEml] = useState("");
	const [srcMalware, setSrcMalware] = useState("");
	const [createdAtMalware, setcreatedAtMalware] = useState("");
	const [pwdMalware, setMalware] = useState("");
	const [stolenCredentialType, setStolenCredentialType] = useState("");

	const [updatedAt, setUpdatedAt] = useState("");
	const [host, setHost] = useState("");

	const [bucket, setBucket] = useState("");
	const [fullPath, setFullPath] = useState("");
	const [size, setSize] = useState("");
	const [type, setType] = useState("");
	const [filename, setFilename] = useState("");
	const [url, setUrl] = useState("");
	const [updateAt, setUpdatedAtCloud] = useState("");

	const [cloudOrISPProvider, setCloudOrISPProvider] = useState("");
	const [highestSeverity, setHighestSeverity] = useState("");
	const [ip, setIp] = useState("");
	const [location, setLocation] = useState("");
	const [subdomains, setSubdomains] = useState("");
	const [operatingSystem, setOperatingSystem] = useState("");
	const [updatedAtIp, setUpdatedAtIp] = useState("");
	const [createdAtIp, setCreatedAtIp] = useState("");
	const [hosts, setHosts] = useState([]);
	const [impacts, setImpacts] = useState([]);
	const [networkServices, setNetworkServices] = useState([]);
	const [openPorts, setOpenPorts] = useState([]);
	const [recommendations, setRecommendations] = useState([]);

	// Add new state variables for file uploads
	const [stolenCredentialsFile, setStolenCredentialsFile] = useState(null);
	const [malwareCredentialsFile, setMalwareCredentialsFile] = useState(null);
	const [socialMediaFile, setSocialMediaFile] = useState(null);
	const [brandMentionsFile, setBrandMentionsFile] = useState(null);
	const [piiUploadFile, setPiiUploadFile] = useState(null);
	const [cloudBucketsFile, setCloudBucketsFile] = useState(null);
	const [mobileAppsFile, setMobileAppsFile] = useState(null);
	// New leaked sessions bulk upload file state
	const [leakedSessionsFile, setLeakedSessionsFile] = useState(null);
	// Telegram and Darkweb bulk upload file state
	const [telegramBulkFile, setTelegramBulkFile] = useState(null);
	const [darkwebBulkFile, setDarkwebBulkFile] = useState(null);

	// Leaked Session state variables
	const [sessionName, setSessionName] = useState("");
	const [sessionValue, setSessionValue] = useState("");
	const [sessionDomain, setSessionDomain] = useState("");
	const [sessionPath, setSessionPath] = useState("/");
	const [sessionExpires, setSessionExpires] = useState("");
	const [sessionFoundDate, setSessionFoundDate] = useState("");

	// Postman Manual Entry state variables
	const [postmanRequestUrl, setPostmanRequestUrl] = useState("");
	const [postmanUrl, setPostmanUrl] = useState("");
	const [postmanUserDetails, setPostmanUserDetails] = useState("");
	const [postmanSwaggerHub, setPostmanSwaggerHub] = useState(false);
	const [postmanApiVersion, setPostmanApiVersion] = useState("");
	const [postmanAuthentication, setPostmanAuthentication] = useState("");
	const [postmanRateLimit, setPostmanRateLimit] = useState("");
	const [postManValue, setpostmanvalue] = useState("");

	const clearStolen = () => {
		setEml("");
		setSrcMalware("");
		setcreatedAtMalware("");
		setMalware("");
		setStolenCredentialType("");
	};

	const clearAppStore = () => {
		setAppName("");
		setAppId("");
		setAppStoreUrl("");
		setAppStoreResource("");
		setAppStoreSeverity("");
		setAppStoreSummary("");
		setAppStoreDetails("");
		setAppStoreAttachment("");
		setAppStoreComments("");
		setAppDeveloperWebsite("");
		setAppDeveloperEmail("");
	};

	const clearSourceCode = () => {
		setRepoUrl("");
		setProgrammingLanguage("");
		setSourceCodeSeverity("");
		setLeakedCode("");
		setSourceCodeComments("");
		setAttachmentUrl("");
		setSourceCodeSuspicious("");
	};

	const clearSocialMedia = () => {
		setFakePageUrl("");
		setSocialMediaPlatform("");
		setSocialSeverity("");
		setSocialComments("");
		setSocialAttachment("");
	};
	const clearDarkWeb = () => {
		setTitleDarkWeb("");
		setThreadLinkDarkWeb("");
		setAuthorNameDarkWeb("");
		setAuthorUrlDarkWeb("");
		setSourceDarkWeb("");
		setAuthorLinkDarkWeb("");
		setAuthorDarkWeb("");
		setDateDarkWeb("");
		setDarkWebAttachmentUrl("");
		setResetDropzone(true);
	};

	const clearMalware = () => {
		setCreatedAt("");
		setUsr("");
		setSrc("");
		setMal("");
		setPwd("");
		setIip("");
		setHid("");
		setFnd("");
	};

	const clearPii = () => {
		setEmail("");
		setIp_address("");
		setUsername("");
		setAddress("");
		setPhone("");
		setDatabase_name("");
		setCreatedAtDate("");
	};

	const clearPastbin = () => {
		setLink("");
		setSnippet("");
		setDate("");
		setTitle("");
		setPastebinAttachmentUrl("");
		setResetPastebinDropzone(true);
	};

	const clearBrandMention = () => {
		setHost("");
		setUpdatedAt("");
	};

	const clearTelegram = () => {
		setGroupName("");
		setMessage("");
		setTelegramDate("");
		setMessageLink("");
		setTelegramImg("");
	};

	const clearCloud = () => {
		setBucket("");
		setFullPath("");
		setSize("");
		setType("");
		setFilename("");
		setUrl("");
		setUpdatedAtCloud("");
	};

	const clearLeakedSession = () => {
		setSessionName("");
		setSessionValue("");
		setSessionDomain("");
		setSessionPath("/");
		setSessionExpires("");
		setSessionFoundDate("");
	};

	const clearPostman = () => {
		setPostmanRequestUrl("");
		setPostmanUrl("");
		setPostmanUserDetails("");
		setPostmanSwaggerHub(false);
		setPostmanApiVersion("");
		setPostmanAuthentication("");
		setPostmanRateLimit("");
		setpostmanvalue("");
	};

	useEffect(() => { }, [socialAttachment]);

	const submitAppStore = () => {
		if (appName === "") {
			toastr.error("Application Name is missing");
			return false;
		}

		if (appStoreUrl === "") {
			toastr.error("Please enter app store url.");
			return false;
		}

		if (appStoreResource === "") {
			toastr.error("Select Application Source");
			return false;
		}

		createAppSToreRecord(
			orgId,
			{
				appName: appName,
				appUrl: appStoreUrl,
				appSource: appStoreResource,
				// appStoreSeverity: appStoreSeverity,
				// appSummary: appSummary,
				// appDeveloperWebsite: appDeveloperWebsite,
				// appDeveloperEmail: appDeveloperEmail,
				// icon: appStoreAttachment,
				// organisationId: orgId,: /:organisationId/queue/roguemobileapps/add
				// description: appStoreDetails,
				// comments: appStoreComments,
			},
			clearAppStore,
			dispatch
		);
	};

	const submitCloud = () => {
		if (bucket === "") {
			toastr.error("Please enter the cloud bucket");
			return false;
		}

		if (fullPath === "") {
			toastr.error("Please enter the full path");
			return false;
		}

		if (size === "") {
			toastr.error("Please enter the size");
			return false;
		}

		if (type === "") {
			toastr.error("Please enter the type");
			return false;
		}

		if (filename === "") {
			toastr.error("Please enter the filename");
			return false;
		}

		if (url === "") {
			toastr.error("Please enter the url");
			return false;
		}

		if (updateAt === "") {
			toastr.error("Please enter the updateAt");
			return false;
		}

		createCloudBucket(
			{
				organisationId: orgId,
				bucket,
				fullPath,
				size,
				type,
				filename,
				url,
				updatedAt: new Date(updateAt)?.toISOString(),
			},
			clearCloud,
			dispatch
		);
	};

	const submitSourceCode = () => {
		if (repoUrl === "") {
			toastr.error("Repository URL is missing");
			return false;
		}
		if (programmingLanguage === "") {
			toastr.error("Please select Programming Language");
			return false;
		}

		if (severityLevel === "") {
			toastr.error("Please select Severity");
			return false;
		}

		if (leakedCode === "") {
			toastr.error("Leaked Code is missing");
			return false;
		}

		createdLeakedCodeRecord(
			{
				repoUrl: repoUrl,
				programmingLanguage: programmingLanguage,
				severityLevel: severityLevel,
				leakedCode: leakedCode,
				organisationId: orgId,
				isSuspicious: true,
			},
			clearSourceCode,
			dispatch
		);
	};

	const submitSocialMedia = () => {
		// Check required fields - only Page URL and Platform are required
		if (fakePageUrl === "") {
			toastr.error("Page URL is missing (required field)");
			return false;
		}
		if (socialMediaPlatform === "") {
			toastr.error("Please select platform (required field)");
			return false;
		}

		if (socialComments === "") {
			toastr.error("Comments are missing (required field)");
			return false;
		}

		// Optional fields - Severity and Comments are not required

		createSocialMediaProfile(
			{
				fakePageUrl: fakePageUrl,
				socialMediaPlatform: socialMediaPlatform,
				socialSeverity: socialSeverity,
				socialComments: socialComments,
				socialAttachment: socialAttachment,
				organisationId: orgId,
				isSuspicious: true,
			},
			clearSocialMedia,
			dispatch
		);
	};

	const submitStolen = () => {
		if (eml === "") {
			toastr.error("Please enter the Email");
			return false;
		}

		if (srcMalware === "") {
			toastr.error("Please enter the Source");
			return false;
		}

		if (createdAtMalware === "") {
			toastr.error("Please enter the Created At");
			return false;
		}

		createStolenCrdentials(
			{
				organisationId: orgId,
				eml,
				src: srcMalware,
				createdAtMalware: new Date(createdAtMalware)?.toISOString(),
				pwd: pwdMalware,
				type: stolenCredentialType,
			},
			clearStolen,
			dispatch
		);
	};

	const submitBrandMention = () => {
		if (host === "") {
			toastr.error("Please enter the Impersonation Url");
			return false;
		}
		// Check if the URL starts with https://
		if (
			!(
				host.toLowerCase().startsWith("https://") ||
				host.toLowerCase().startsWith("http://")
			)
		) {
			toastr.error("Impersonation URL must start with https://");
			return false;
		}
		// if (updatedAt === "") {
		//   toastr.error("Please enter the update At");
		//   return false;
		// }
		createBrandMention(
			orgId,
			{ impersonationUrl: host },
			clearBrandMention,
			dispatch
		);
	};

	const submitPii = () => {
		// if (username === "") {
		//   toastr.error("Please enter the username");
		//   return false;
		// }

		// if (address === "") {
		//   toastr.error("Please enter the address");
		//   return false;
		// }

		// if (phone === "") {
		//   toastr.error("Please enter the phone");
		//   return false;
		// }

		// if (email === "") {
		//   toastr.error("Please enter the email");
		//   return false;
		// }

		// if (ip_address === "") {
		//   toastr.error("Please enter the IP address");
		//   return false;
		// }

		if (database_name === "") {
			toastr.error("Please enter the database name");
			return false;
		}

		if (createdAtDate === "") {
			toastr.error("Please enter the created date");
			return false;
		}
		createPii(
			{
				organisationId: orgId,
				database_name,
				createdAt: new Date(createdAtDate)?.toISOString(),
				phone,
				mal,
				address,
				username,
				ip_address,
				email,
			},
			clearPii,
			dispatch
		);
	};

	const submitMalware = () => {
		if (fnd === "") {
			toastr.error("Please enter the fnd");
			return false;
		}

		if (hid === "") {
			toastr.error("Please enter the hid");
			return false;
		}

		if (iip === "") {
			toastr.error("Please enter the iip");
			return false;
		}

		if (pwd === "") {
			toastr.error("Please enter the pwd");
			return false;
		}

		if (usr === "") {
			toastr.error("Please enter the usr");
			return false;
		}

		if (src === "") {
			toastr.error("Please enter the src");
			return false;
		}

		if (mal === "") {
			toastr.error("please enter the mal");
			return false;
		}

		if (createdAt === "") {
			toastr.error("please enter the createdAt");
			return false;
		}

		createMalwareCredentials(
			{
				organisationId: orgId,
				usr,
				createdAt: new Date(createdAt)?.toISOString(),
				src,
				mal,
				pwd,
				iip,
				hid,
				fnd,
			},
			clearMalware,
			dispatch
		);
	};

	const f = () => {
		if (titleDarkWeb === "") {
			toastr.error("Title is missing");
			return false;
		}
		if (threadLinkDarkWeb === "") {
			toastr.error("Thread link is missing");
			return false;
		}

		if (authorNameDarkWeb === "") {
			toastr.error("Author name is missing");
			return false;
		}

		if (sourceSourceDarkWeb === "") {
			toastr.error("source is missing");
			return false;
		}
		if (authorLinkDarkWeb === "") {
			toastr.error("Author link is missing");
			return false;
		}
		if (authorDarkWeb === "") {
			toastr.error("Author is missing");
			return false;
		}
		if (darkWebAttachmentUrl === "") {
			toastr.error("Please upload attachment.");
			return false;
		}

		if (dateDarkWeb === "") {
			toastr.error("Date is missing");
			return false;
		}

		createDarkWebRecord(
			{
				organisationId: orgId,
				title: titleDarkWeb,
				thread_link: threadLinkDarkWeb,
				author_name: authorNameDarkWeb,
				// "author_url": authorUrlDarkWeb,
				date: dateDarkWeb,
				fixed_screenshot_path: darkWebAttachmentUrl,
				fullpage_screenshot_url: darkWebAttachmentUrl,
				source: sourceSourceDarkWeb,
				author_link: authorLinkDarkWeb,
				author: authorDarkWeb,
			},
			clearDarkWeb,
			dispatch
		);
	};

	const submitPastbinSearch = () => {
		if (title === "") {
			toastr.error("Please Enter the Title");
			return false;
		}
		if (link === "") {
			toastr.error("Please Enter the link");
			return false;
		}
		if (date === "") {
			toastr.error("Please Enter the date");
			return false;
		}
		if (snippet === "") {
			toastr.error("Please Enter the Snippet");
			return false;
		}
		const payload = {
			title: title,
			snippet: snippet,
			link: link,
			organisationId: orgId,
			date: date,
		};

		if (pastebinAttachmentUrl) {
			payload.screenshot_url = pastebinAttachmentUrl;
			payload.fixed_screenshot_path = pastebinAttachmentUrl;
		}

		createPastbinSearch(payload, clearPastbin, dispatch);
	};

	const submitTelegram = () => {
		if (groupname === "") {
			toastr.error("Please Enter the Name");
			return false;
		}
		if (messagelink === "") {
			toastr.error("Please Enter the link");
			return false;
		}
		if (telegramDate === "") {
			toastr.error("Please Enter the date");
			return false;
		}
		if (message === "") {
			toastr.error("Please Enter the Message");
			return false;
		}
		telegramPost(
			{
				date: telegramDate,
				group_name: groupname,
				message_link: messagelink,
				organisationId: orgId,
				isRemidiated: false,
				message: message,
				s3_media_url: telegramImg,
			},
			clearTelegram,
			dispatch
		);
	};

	const addValue = (id) => {
		const inputValue = document.getElementById(id).value;

		if (inputValue.trim() === "") {
			const errorMessages = {
				hosts: "Please enter a host.",
				impacts: "Please enter an impact.",
				networkServices: "Please enter a network service.",
				openPorts: "Please enter an open port.",
				recommendations: "Please enter a recommendation.",
			};
			toastr.error(errorMessages[id] || "Input cannot be empty!");
			return; // Avoid adding empty values
		}

		switch (id) {
			case "hosts":
				setHosts([...hosts, inputValue]);
				break;
			case "impacts":
				setImpacts([...impacts, inputValue]);
				break;
			case "networkServices":
				setNetworkServices([...networkServices, inputValue]);
				break;
			case "openPorts":
				setOpenPorts([...openPorts, inputValue]);
				break;
			case "recommendations":
				setRecommendations([...recommendations, inputValue]);
				break;
			default:
				break;
		}

		document.getElementById(id).value = ""; // Clear the input field
	};

	const removeValue = (id, index) => {
		switch (id) {
			case "hosts":
				setHosts(hosts.filter((_, i) => i !== index));
				break;
			case "impacts":
				setImpacts(impacts.filter((_, i) => i !== index));
				break;
			case "networkServices":
				setNetworkServices(
					networkServices.filter((_, i) => i !== index)
				);
				break;
			case "openPorts":
				setOpenPorts(openPorts.filter((_, i) => i !== index));
				break;
			case "recommendations":
				setRecommendations(
					recommendations.filter((_, i) => i !== index)
				);
				break;
			default:
				break;
		}
	};

	const clearPortsIp = () => {
		setHosts([]);
		setImpacts([]);
		setNetworkServices([]);
		setOpenPorts([]);
		setRecommendations([]);
		setCloudOrISPProvider("");
		setHighestSeverity("");
		setIp("");
		setLocation("");
		setSubdomains("");
		setOperatingSystem("");
		setOperatingSystem("");
		setCreatedAtIp("");
		setUpdatedAtIp("");
	};

	const submitIpPorts = () => {
		if (cloudOrISPProvider === "") {
			toastr.error("Please enter cloud or isp provider.");
			return;
		}
		if (highestSeverity === "") {
			toastr.error("Please enter highest serverity.");
			return;
		}
		if (ip === "") {
			toastr.error("Please enter ip.");
			return;
		}
		if (location === "") {
			toastr.error("Please enter location.");
			return;
		}
		if (subdomains === "") {
			toastr.error("Please enter subdomain.");
			return;
		}
		if (operatingSystem === "") {
			toastr.error("Please enter operating system.");
			return;
		}
		if (createdAtIp === "") {
			toastr.error("Please enter created at.");
			return;
		}
		if (updatedAtIp === "") {
			toastr.error("Please enter updated at.");
			return;
		}
		if (hosts.length === 0) {
			toastr.error("Please add at least one host.");
			return;
		}
		if (impacts.length === 0) {
			toastr.error("Please add at least one impact.");
			return;
		}
		if (networkServices.length === 0) {
			toastr.error("Please add at least one network service.");
			return;
		}
		if (openPorts.length === 0) {
			toastr.error("Please add at least one open port.");
			return;
		}
		if (recommendations.length === 0) {
			toastr.error("Please add at least one recommendation.");
			return;
		}
		createIpPorts(
			{
				hosts,
				impacts,
				networkServices,
				openPorts,
				recommendations,
				location,
				ip,
				createdAt: new Date(createdAtIp)?.toISOString(),
				updateAt: new Date(updatedAtIp)?.toISOString(),
				highestSeverity,
				cloudOrISPProvider,
				operatingSystem,
				subdomains,
				organisationId: orgId,
			},
			clearPortsIp
		);
	};

	const submitLeakedSession = () => {
		// Enhanced validation for blank/empty fields with comprehensive checks
		// Session Name validation
		if (sessionName == "") {
			toastr.error(
				"Session name is required and cannot be blank or empty"
			);
			return false;
		}

		if (sessionName.trim().length < 2) {
			toastr.error("Session name must be at least 2 characters long");
			return false;
		}

		// Session Value validation
		if (
			!sessionValue ||
			typeof sessionValue !== "string" ||
			sessionValue.trim() === "" ||
			sessionValue.trim().length === 0
		) {
			toastr.error(
				"Session value is required and cannot be blank or empty"
			);
			return false;
		}

		if (sessionValue.trim().length < 10) {
			toastr.error(
				"Session value seems too short. Please enter a valid session token"
			);
			return false;
		}

		// Domain validation
		if (
			!sessionDomain ||
			typeof sessionDomain !== "string" ||
			sessionDomain.trim() === "" ||
			sessionDomain.trim().length === 0
		) {
			toastr.error("Domain is required and cannot be blank or empty");
			return false;
		}

		// Enhanced domain format validation
		const domainRegex =
			/^[a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?)*$/;
		const trimmedDomain = sessionDomain.trim();

		if (!domainRegex.test(trimmedDomain)) {
			toastr.error(
				"Please enter a valid domain format (e.g., example.com)"
			);
			return false;
		}

		if (trimmedDomain.length < 4) {
			toastr.error(
				"Domain name is too short. Please enter a valid domain"
			);
			return false;
		}

		// Found Date validation
		if (
			!sessionFoundDate ||
			typeof sessionFoundDate !== "string" ||
			sessionFoundDate.trim() === "" ||
			sessionFoundDate.trim().length === 0
		) {
			toastr.error("Found date is required and cannot be blank or empty");
			return false;
		}

		// Validate date format and that it's not in the future
		const foundDateObj = new Date(sessionFoundDate);
		const today = new Date();
		today.setHours(23, 59, 59, 999); // Set to end of today

		if (isNaN(foundDateObj.getTime())) {
			toastr.error("Please enter a valid found date");
			return false;
		}

		if (foundDateObj > today) {
			toastr.error("Found date cannot be in the future");
			return false;
		}

		// Session Expires validation (if provided)
		if (
			sessionExpires &&
			typeof sessionExpires === "string" &&
			sessionExpires.trim() !== ""
		) {
			const expiresDateObj = new Date(sessionExpires);
			if (isNaN(expiresDateObj.getTime())) {
				toastr.error("Please enter a valid expiration date and time");
				return false;
			}

			// Check if expires date is reasonable (not too far in the past)
			const oneDayAgo = new Date();
			oneDayAgo.setDate(oneDayAgo.getDate() - 1);
			if (expiresDateObj < oneDayAgo) {
				toastr.error(
					"⚠️ Warning: Session expiration date is more than 1 day in the past"
				);
				// Don't return false, just warn
			}
		}

		// All validations passed, prepare data
		const sessionData = {
			name: sessionName.trim(),
			val: sessionValue.trim(),
			dom: sessionDomain.trim(),
			path: (sessionPath && sessionPath.trim()) || "/",
			fnd: sessionFoundDate,
		};

		// Add expires field if provided and valid
		if (sessionExpires && sessionExpires.trim() !== "") {
			try {
				sessionData.expires = new Date(sessionExpires).toISOString();
			} catch (error) {
				toastr.error("Invalid expiration date format");
				return false;
			}
		}

		// Success callback to redirect to show details page
		const onSuccess = () => {
			clearLeakedSession();
			setTimeout(() => {
				history.push(`/show-details/${orgId}`);
			}, 1500);
		};

		createManualLeakedSession(orgId, sessionData, onSuccess, dispatch);
	};

	const submitPostman = () => {
		// Enhanced validation for blank/empty fields

		// Request URL validation
		if (!postmanRequestUrl || postmanRequestUrl.trim() === "") {
			toastr.error(
				"Request URL is required and cannot be blank or empty"
			);
			return false;
		}

		// URL validation
		if (!postmanUrl || postmanUrl.trim() === "") {
			toastr.error("URL is required and cannot be blank or empty");
			return false;
		}

		// User Details validation
		if (!postmanUserDetails || postmanUserDetails.trim() === "") {
			toastr.error(
				"API description/user details is required and cannot be blank or empty"
			);
			return false;
		}

		// Validate URL format
		const urlRegex = /^https?:\/\/.+/;
		if (!urlRegex.test(postmanRequestUrl.trim())) {
			toastr.error(
				"Please enter a valid request URL starting with http:// or https://"
			);
			return false;
		}

		if (!urlRegex.test(postmanUrl.trim())) {
			toastr.error(
				"Please enter a valid URL starting with http:// or https://"
			);
			return false;
		}

		// Prepare postman data
		const postmanData = {
			request_url: postmanRequestUrl.trim(),
			url: postmanUrl.trim(),
			user_details: postmanUserDetails.trim(),
			value: [postManValue.trim()],
			swaggerHub: postmanSwaggerHub,
			type: "postman",
			additional_data: {},
		};

		createPostmanRecord(orgId, postmanData, dispatch);
	};

	// Update the FileUploadSection component with improved UI and cross button
	const FileUploadSection = ({
		title,
		description,
		fileState,
		setFileState,
		handleUpload,
		sampleFileUrl,
		accept = ".csv,.xlsx,.xls",
	}) => {
		const clearFile = () => {
			setFileState(null);
		};

		return (
			<div className="col-12 mb-4">
				<div className="card border-0 shadow-sm">
					<div className="card-body p-4">
						{/* Header with title and download button */}
						<div className="d-flex justify-content-between align-items-center mb-4">
							<div>
								{title && (
									<h6 className="mb-1 font-weight-bold">
										{title}
									</h6>
								)}
								<p className="text-muted mb-0 small">
									Import your data using CSV or Excel file
								</p>
							</div>
							{sampleFileUrl && (
								<a
									href={sampleFileUrl}
									download
									className="btn btn-outline-primary btn-sm d-flex align-items-center"
								>
									<i className="fa fa-download mr-2"></i>
									Sample Template
								</a>
							)}
						</div>

						{/* Required columns info */}
						<div
							className="alert alert-info bg-light border-info d-flex align-items-center mb-4"
							role="alert"
						>
							<i className="fa fa-info-circle text-info mr-3 fa-lg"></i>
							<div className="small">
								<strong>Required columns:</strong>{" "}
								{description.split("Required columns:")[1]}
							</div>
						</div>

						{/* Upload zone */}
						<div className="upload-zone position-relative p-4 rounded-lg border-2 border-dashed text-center bg-light">
							<input
								type="file"
								className="position-absolute w-100 h-100 opacity-0 cursor-pointer"
								style={{ top: 0, left: 0, zIndex: 2 }}
								onChange={(e) =>
									setFileState(e.target.files[0])
								}
								accept={accept}
								value=""
							/>
							<div className="py-3">
								<i className="fa fa-cloud-upload fa-3x text-primary mb-3"></i>
								<h6 className="mb-2">
									Drag & drop your file here
								</h6>
								<p className="text-muted small mb-0">
									or click to browse
								</p>
							</div>
						</div>

						{/* Selected file info and upload button */}
						{fileState && (
							<div className="mt-3 bg-light p-3 rounded position-relative">
								<button
									className="btn btn-sm position-absolute"
									onClick={clearFile}
									title="Remove file"
									style={{
										top: "-10px",
										right: "-10px",
										backgroundColor: "#fff",
										borderRadius: "50%",
										minWidth: "25px",
										minHeight: "25px",
										padding: "0",
										boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
										border: "1px solid #dee2e6",
									}}
								>
									<i className="fa fa-times text-danger"></i>
								</button>
								<div className="d-flex align-items-center justify-content-between">
									<div className="d-flex align-items-center">
										<i className="fa fa-file-excel-o text-success mr-2"></i>
										<span
											className="text-truncate"
											style={{ maxWidth: "200px" }}
										>
											{fileState.name}
										</span>
									</div>
									<button
										className="btn btn-primary d-flex align-items-center"
										onClick={handleUpload}
									>
										<i className="fa fa-upload mr-2"></i>
										Upload File
									</button>
								</div>
							</div>
						)}
					</div>
				</div>

				<style jsx>{`
					.border-2 {
						border-width: 2px !important;
					}
					.border-dashed {
						border-style: dashed !important;
					}
					.cursor-pointer {
						cursor: pointer;
					}
					.opacity-0 {
						opacity: 0;
					}
					.upload-zone:hover {
						background-color: #f8f9fa !important;
						border-color: #007bff !important;
					}
				`}</style>
			</div>
		);
	};

	// Update the handleFileUpload function to ensure file is removed after upload
	const handleFileUpload = async (file, url, type) => {
		if (!file) {
			toastr.error("Please select a file first");
			return;
		}

		const formData = new FormData();
		formData.append("file", file);
		formData.append("organisationId", orgId);

		try {
			const response = await axios.post(url, formData);
			if (response.data.error === false) {
				toastr.success(
					response.data.userMessage || `${type} uploaded successfully`
				);
				// Reset file state based on type
				switch (type) {
					case "Stolen credentials":
						setStolenCredentialsFile(null);
						clearStolen();
						break;
					case "Malware credentials":
						setMalwareCredentialsFile(null);
						clearMalware();
						break;
					case "Social media profiles":
						setSocialMediaFile(null);
						clearSocialMedia();
						break;
					case "Brand mentions":
						setBrandMentionsFile(null);
						clearBrandMention();
						break;
					case "Rogue mobile apps":
						setMobileAppsFile(null);
						clearAppStore();
						break;
					case "Leaked sessions":
						setLeakedSessionsFile(null);
						clearLeakedSession();
						break;
					case "PII details":
						setPiiUploadFile(null);
						clearPii();
						break;
					case "Cloud buckets":
						setCloudBucketsFile(null);
						clearCloud();
						break;
					case "Telegram monitoring":
						setTelegramBulkFile(null);
						clearTelegram();
						break;
					case "Darkweb forum":
						setDarkwebBulkFile(null);
						clearDarkWeb();
						break;
				}
				// Reset the file input
				const fileInput = document.querySelector('input[type="file"]');
				if (fileInput) {
					fileInput.value = "";
				}
			} else {
				toastr.error(
					response.data.userMessage || "Error uploading file"
				);
			}
		} catch (error) {
			toastr.error(
				error.response?.data?.userMessage ||
				error.response?.data?.message ||
				"Error uploading file"
			);
		}
	};

	return (
		<>
			<div className="container-fluid">
				<div className="block-header">
					<div className="row clearfix">
						<div className="col-md-6">
							<h2 className="welcome-text">Feed Information</h2>
							<nav aria-label="breadcrumb" className="mt-1">
								<ol className="breadcrumb">
									<li className="breadcrumb-item">
										<Link
											to="/"
											className="welcome-textSmall"
										>
											Home
										</Link>
									</li>

									<li
										className="breadcrumb-item active"
										aria-current="page"
									>
										Summary
									</li>
								</ol>
							</nav>
						</div>
						<div className="col-md-6 text-right hidden-xs">
							<Link
								className="btn btn-success btn-sm mr-1"
								to={`/show-details/${orgId}`}
							>
								Back
							</Link>
						</div>
					</div>
				</div>

				<div className="row clearfix">
					<div className="col-lg-12 col-md-12 col-sm-12">
						<div className="card">
							<div className="body">
								<div id="wizard_horizontal">
									<Tabs
										defaultActiveKey="First Step"
										id="uncontrolled-tab-example"
									>
										<Tab
											eventKey="First Step"
											title="Mobile Application"
											tabClassName="form_wizard_tab form_wizard_width"
										>
											<div className="row clearfix">
												<div className="col-xl-12 col-lg-12 col-md-12">
													<div className="card">
														<div className="body">
															<div className="row clearfix">
																<FileUploadSection
																	title="Bulk Upload Rogue Mobile Apps"
																	description="Required columns: app_name, app_url, source (google/apple/others), comments (optional)"
																	fileState={mobileAppsFile}
																	setFileState={setMobileAppsFile}
																	handleUpload={() =>
																		handleFileUpload(
																			mobileAppsFile,
																			`${API_URL}/get-appsv2/${orgId}/upload-excel`,
																			"Rogue mobile apps"
																		)
																	}
																	sampleFileUrl={fileUrls.MobileApp}
																	accept=".xlsx"
																/>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			value={
																				appName
																			}
																			onChange={(
																				e
																			) =>
																				setAppName(
																					e
																						.target
																						.value
																				)
																			}
																			placeholder="Application Name *"
																		/>
																	</div>
																</div>

																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			placeholder="Application URL *"
																			className="form-control"
																			value={
																				appStoreUrl
																			}
																			onChange={(
																				e
																			) =>
																				setAppStoreUrl(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<select
																			className="form-control"
																			value={
																				appStoreResource
																			}
																			onChange={(
																				e
																			) =>
																				setAppStoreResource(
																					e
																						.target
																						.value
																				)
																			}
																		>
																			<option value="">
																				--
																				Select
																				Source
																				*--
																			</option>
																			<option value="google">
																				Google
																				Play
																				Store
																			</option>
																			<option value="apple">
																				Apple
																				Store
																			</option>
																			<option value="others">
																				Third
																				Party
																				Store
																			</option>
																		</select>
																	</div>
																</div>
															</div>
															<button
																type="button"
																className="btn btn-round btn-primary mr-1"
																onClick={(
																	e
																) => {
																	// e.preventDefault();
																	submitAppStore();
																}}
															>
																Submit
															</button>{" "}
															&nbsp;&nbsp;
														</div>
													</div>
												</div>
											</div>
										</Tab>
										<Tab
											eventKey="Second Step"
											title="Source Code"
											tabClassName="form_wizard_tab form_wizard_width"
										>
											<div className="row clearfix">
												<div className="col-xl-12 col-lg-12 col-md-12">
													<div className="card">
														<div className="body">
															<div className="row clearfix">
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Repository URL"
																			value={
																				repoUrl
																			}
																			onChange={(
																				e
																			) =>
																				setRepoUrl(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<select
																			className="form-control"
																			value={
																				programmingLanguage
																			}
																			onChange={(
																				e
																			) =>
																				setProgrammingLanguage(
																					e
																						.target
																						.value
																				)
																			}
																		>
																			<option value="">
																				--
																				Select
																				Programming
																				Language
																				--
																			</option>
																			<option value="java">
																				Java
																			</option>
																			<option value="php">
																				PHP
																			</option>
																			<option value="python">
																				Python
																			</option>
																			<option value="c++">
																				C++
																			</option>
																			<option value="c#">
																				C#
																			</option>
																			<option value="r">
																				R
																			</option>
																			<option value="js">
																				Java
																				Script
																			</option>
																			<option value="golang">
																				Go
																				Lang
																			</option>
																			<option value="ts">
																				Type
																				Script
																			</option>
																			<option value="ruby">
																				Ruby
																			</option>
																		</select>
																	</div>
																</div>

																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<select
																			className="form-control"
																			value={
																				severityLevel
																			}
																			onChange={(
																				e
																			) =>
																				setSourceCodeSeverity(
																					e
																						.target
																						.value
																				)
																			}
																		>
																			<option value="">
																				--
																				Select
																				Severity
																				--
																			</option>
																			<option value="critical">
																				Critical
																			</option>
																			<option value="high">
																				High
																			</option>
																			<option value="medium">
																				Medium
																			</option>
																			<option value="low">
																				Low
																			</option>
																		</select>
																	</div>
																</div>

																<div className="col-lg-12 col-md-12">
																	<div className="form-group">
																		<textarea
																			rows="4"
																			type="text"
																			className="form-control"
																			placeholder="Leaked Code"
																			value={
																				leakedCode
																			}
																			onChange={(
																				e
																			) =>
																				setLeakedCode(
																					e
																						.target
																						.value
																				)
																			}
																		></textarea>
																	</div>
																</div>
															</div>
															<button
																type="button"
																className="btn btn-round btn-primary mr-1"
																onClick={(
																	e
																) => {
																	e.preventDefault();
																	submitSourceCode();
																}}
															>
																Submit
															</button>{" "}
															&nbsp;&nbsp;
														</div>
													</div>
												</div>
											</div>
										</Tab>
										<Tab
											eventKey="Third Step"
											title="Social Media Profile"
											tabClassName="form_wizard_tab form_wizard_width"
										>
											<div className="row clearfix">
												<div className="col-xl-12 col-lg-12 col-md-12">
													<div className="card">
														<div className="body">
															<div className="row clearfix">
																<FileUploadSection
																	title="Bulk Upload Social Media Profiles"
																	description="Alternatively, upload CSV or Excel file containing multiple social media profiles. Required columns: Platform, Page Url, Comments"
																	fileState={
																		socialMediaFile
																	}
																	setFileState={
																		setSocialMediaFile
																	}
																	handleUpload={() =>
																		handleFileUpload(
																			socialMediaFile,
																			`${API_URL}/getFakeSocialMediav2/${orgId}/upload-social-media-profiles`,
																			"Social media profiles"
																		)
																	}
																	sampleFileUrl={
																		fileUrls.socialMediaProfiles
																	}
																/>

																<div className="col-12 mb-3">
																	<div
																		className="alert alert-info"
																		role="alert"
																	>
																		<strong>
																			Required
																			fields:
																		</strong>{" "}
																		Platform,
																		Page
																		Url,
																		Comments
																		<br />
																	</div>
																</div>

																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<label>
																			Page/Profile
																			URL{" "}
																			<span className="text-danger">
																				*
																			</span>
																		</label>
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Page/Profile URL (required)"
																			value={
																				fakePageUrl
																			}
																			onChange={(
																				e
																			) =>
																				setFakePageUrl(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<label>
																			Platform{" "}
																			<span className="text-danger">
																				*
																			</span>
																		</label>
																		<select
																			className="form-control"
																			value={
																				socialMediaPlatform
																			}
																			onChange={(
																				e
																			) =>
																				setSocialMediaPlatform(
																					e
																						.target
																						.value
																				)
																			}
																		>
																			<option value="">
																				--
																				Select
																				Platform
																				(required)
																				--
																			</option>
																			<option value="linkedin">
																				LinkedIn
																			</option>
																			<option value="facebook">
																				Facebook
																			</option>
																			<option value="instagram">
																				Instagram
																			</option>
																			<option value="twitter">
																				Twitter
																			</option>
																			<option value="youtube">
																				Youtube
																			</option>
																			<option value="telegram">
																				Telegram
																			</option>
																		</select>
																	</div>
																</div>

																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<label>
																			Severity{" "}
																			<span className="text-muted">
																				(optional)
																			</span>
																		</label>
																		<select
																			className="form-control"
																			value={socialSeverity}
																			onChange={(e) => setSocialSeverity(e.target.value)}
																		>
																			<option value="">-- Select Severity --</option>
																			<option value="critical">Critical</option>
																			<option value="high">High</option>
																			<option value="medium">Medium</option>
																			<option value="low">Low</option>
																		</select>
																	</div>
																</div>

																<div className="col-lg-12 col-md-12">
																	<div className="form-group">
																		<label>
																			Comments
																		</label>
																		<textarea
																			rows="4"
																			type="text"
																			className="form-control"
																			placeholder="Comments (optional)"
																			value={
																				socialComments
																			}
																			onChange={(
																				e
																			) =>
																				setSocialComments(
																					e
																						.target
																						.value
																				)
																			}
																		></textarea>
																	</div>
																</div>
															</div>
															<button
																type="button"
																className="btn btn-round btn-primary mr-1"
																onClick={(
																	e
																) => {
																	// e.preventDefault();
																	submitSocialMedia();
																}}
															>
																Submit
															</button>{" "}
															&nbsp;&nbsp;
														</div>
													</div>
												</div>
											</div>
										</Tab>
										<Tab
											eventKey="Forth Step"
											title="Dark Web"
											tabClassName="form_wizard_tab form_wizard_width"
										>
											<div className="row clearfix">
												<div className="col-xl-12 col-lg-12 col-md-12">
													<div className="card">
														<div className="body">
															<FileUploadSection
																title="Bulk Upload Dark Web Forum"
																description="Required columns: title, thread_link, author_name, source, author_link, created_at, evidence_url (optional)"
																fileState={darkwebBulkFile}
																setFileState={setDarkwebBulkFile}
																handleUpload={() =>
																	handleFileUpload(
																		darkwebBulkFile,
																		`${API_URL}/darkwebForum/${orgId}/bulk-upload`,
																		"Darkweb forum"
																	)
																}
																sampleFileUrl={fileUrls.darkwebForum}
															/>
															<div className="row clearfix">
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="title"
																			value={
																				titleDarkWeb
																			}
																			onChange={(
																				e
																			) =>
																				setTitleDarkWeb(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="thread link"
																			value={
																				threadLinkDarkWeb
																			}
																			onChange={(
																				e
																			) =>
																				setThreadLinkDarkWeb(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="author name"
																			value={
																				authorNameDarkWeb
																			}
																			onChange={(
																				e
																			) => {
																				setAuthorNameDarkWeb(
																					e
																						.target
																						.value
																				);
																				setAuthorDarkWeb(
																					e
																						.target
																						.value
																				);
																			}}
																		/>
																	</div>
																</div>

																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="source"
																			value={
																				sourceSourceDarkWeb
																			}
																			onChange={(
																				e
																			) =>
																				setSourceDarkWeb(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>

																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="author link"
																			value={
																				authorLinkDarkWeb
																			}
																			onChange={(
																				e
																			) =>
																				setAuthorLinkDarkWeb(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>

																{/* <div className="col-lg-6 col-md-12">
                                  <div className="form-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="author"
                                      value={authorDarkWeb}
                                      onChange={(e) =>
                                        setAuthorDarkWeb(e.target.value)
                                      }
                                    />
                                  </div>
                                </div> */}

																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<label htmlFor="createdAt">
																			Created
																			At
																		</label>
																		<input
																			type="date"
																			className="form-control"
																			placeholder="author"
																			value={
																				dateDarkWeb
																			}
																			onChange={(
																				e
																			) =>
																				setDateDarkWeb(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>

																<div className="col-lg-6 col-md-12">
																	<div className="card">
																		<div className="header">
																			<h2>
																				Upload
																				Evidence
																			</h2>
																		</div>
																		<div className="body">
																			<Dropzone
																				data="upload_darkweb"
																				variable={
																					setDarkWebAttachmentUrl
																				}
																				reset={
																					resetDropzone
																				}
																				onReset={() =>
																					setResetDropzone(
																						false
																					)
																				}
																			/>
																		</div>
																	</div>
																</div>
															</div>
															<button
																type="button"
																className="btn btn-round btn-primary mr-1"
																onClick={(
																	e
																) => {
																	// e.preventDefault();
																	f();
																}}
															>
																Submit
															</button>{" "}
															&nbsp;&nbsp;
														</div>
													</div>
												</div>
											</div>
										</Tab>
										<Tab
											eventKey="Five Step"
											title="Pastebin Search"
											tabClassName="form_wizard_tab form_wizard_width"
										>
											<div className="row clearfix">
												<div className="col-xl-12 col-lg-12 col-md-12">
													<div className="card">
														<div className="body">
															<div className="row clearfix align-items-end">
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="title"
																			value={
																				title
																			}
																			onChange={(
																				e
																			) =>
																				setTitle(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="snippet"
																			value={
																				snippet
																			}
																			onChange={(
																				e
																			) =>
																				setSnippet(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<label htmlFor="createdAt">
																			Created
																			At
																		</label>
																		<input
																			type="date"
																			className="form-control"
																			placeholder="date"
																			value={
																				date
																			}
																			onChange={(
																				e
																			) =>
																				setDate(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="link"
																			value={
																				link
																			}
																			onChange={(
																				e
																			) =>
																				setLink(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="card">
																		<div className="header">
																			<h2>Upload Evidence</h2>
																		</div>
																		<div className="body">
																			<Dropzone
																				data="pastebin"
																				variable={setPastebinAttachmentUrl}
																				reset={resetPastebinDropzone}
																				onReset={() => setResetPastebinDropzone(false)}
																			/>
																		</div>
																	</div>
																</div>
															</div>
															<button
																type="button"
																className="btn btn-round btn-primary mr-1"
																onClick={(
																	e
																) => {
																	submitPastbinSearch();
																}}
															>
																Submit
															</button>{" "}
															&nbsp;&nbsp;
														</div>
													</div>
												</div>
											</div>
										</Tab>
										<Tab
											eventKey="Six Step"
											title="Telegram Monitoring"
											tabClassName="form_wizard_tab form_wizard_width"
										>
											<div className="row clearfix">
												<div className="col-xl-12 col-lg-12 col-md-12">
													<div className="card">
														<div className="body">
															<FileUploadSection
																title="Bulk Upload Telegram Monitoring"
																description="Required columns: group_name, message_link, created_at, message, evidence_url (optional)"
																fileState={telegramBulkFile}
																setFileState={setTelegramBulkFile}
																handleUpload={() =>
																	handleFileUpload(
																		telegramBulkFile,
																		`${API_URL}/telegram-monitoring/${orgId}/bulk-upload`,
																		"Telegram monitoring"
																	)
																}
																sampleFileUrl={fileUrls.telegramMonitoring}
															/>
															<div className="row clearfix">
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Group Name"
																			value={
																				groupname
																			}
																			onChange={(
																				e
																			) =>
																				setGroupName(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Message Link"
																			value={
																				messagelink
																			}
																			onChange={(
																				e
																			) =>
																				setMessageLink(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<label htmlFor="createdAt">
																			Created
																			At
																		</label>
																		<input
																			type="date"
																			className="form-control"
																			placeholder="date"
																			value={
																				telegramDate
																			}
																			onChange={(
																				e
																			) =>
																				setTelegramDate(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-12 col-md-12">
																	<div className="form-group">
																		<textarea
																			rows="4"
																			type="text"
																			className="form-control"
																			placeholder="Message"
																			value={
																				message
																			}
																			onChange={(
																				e
																			) =>
																				setMessage(
																					e
																						.target
																						.value
																				)
																			}
																		></textarea>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="card">
																		<div className="header">
																			<h2>
																				Upload
																				Evidence
																			</h2>
																		</div>
																		<div className="body">
																			<Dropzone
																				data="upload_telegram"
																				variable={
																					setTelegramImg
																				}
																				reset={
																					resetDropzone
																				}
																				onReset={() =>
																					setResetDropzone(
																						false
																					)
																				}
																			/>
																		</div>
																	</div>
																</div>
															</div>
															<button
																type="button"
																className="btn btn-round btn-primary mr-1"
																onClick={(
																	e
																) => {
																	// e.preventDefault();
																	submitTelegram();
																}}
															>
																Submit
															</button>{" "}
															&nbsp;&nbsp;
														</div>
													</div>
												</div>
											</div>
										</Tab>
										<Tab
											eventKey="Seven Step"
											title="Malware Credentials"
											tabClassName="form_wizard_tab form_wizard_width"
										>
											<div className="row clearfix">
												<div className="col-xl-12 col-lg-12 col-md-12">
													<div className="card">
														<div className="body">
															<div className="row clearfix">
																<FileUploadSection
																	title="Upload Malware Credentials File"
																	description="Upload CSV or Excel file containing malware credentials data. Required columns: usr, src, created_at, pwd, iip, hid, fnd, mal"
																	fileState={
																		malwareCredentialsFile
																	}
																	setFileState={
																		setMalwareCredentialsFile
																	}
																	handleUpload={() =>
																		handleFileUpload(
																			malwareCredentialsFile,
																			`${API_URL}/getMalwareCredentials/upload-malware-credentials/${orgId}`,
																			"Malware credentials"
																		)
																	}
																	sampleFileUrl={
																		fileUrls.malwareCredentials
																	}
																/>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="User"
																			value={
																				usr
																			}
																			onChange={(
																				e
																			) =>
																				setUsr(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Url"
																			value={
																				src
																			}
																			onChange={(
																				e
																			) =>
																				setSrc(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Malware type"
																			value={
																				mal
																			}
																			onChange={(
																				e
																			) =>
																				setMal(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="password"
																			className="form-control"
																			placeholder="Password"
																			value={
																				pwd
																			}
																			onChange={(
																				e
																			) =>
																				setPwd(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="IP Address"
																			value={
																				iip
																			}
																			onChange={(
																				e
																			) =>
																				setIip(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="HID"
																			value={
																				hid
																			}
																			onChange={(
																				e
																			) =>
																				setHid(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<label htmlFor="createdAt">
																			Created
																			At
																		</label>
																		<input
																			id="createdAt"
																			type="date"
																			className="form-control"
																			value={
																				createdAt
																			}
																			onChange={(
																				e
																			) =>
																				setCreatedAt(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<label htmlFor="foundDate">
																			Found
																			Date
																		</label>
																		<input
																			id="foundDate"
																			type="date"
																			className="form-control"
																			value={
																				fnd
																			}
																			onChange={(
																				e
																			) =>
																				setFnd(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
															</div>
															<button
																type="button"
																className="btn btn-round btn-primary mr-1"
																onClick={
																	submitMalware
																}
															>
																Submit
															</button>{" "}
															&nbsp;&nbsp;
														</div>
													</div>
												</div>
											</div>
										</Tab>
										<Tab
											eventKey="Eight Step"
											title="Pii"
											tabClassName="form_wizard_tab form_wizard_width"
										>
											<div className="row clearfix">
												<div className="col-xl-12 col-lg-12 col-md-12">
													<div className="card">
														<div className="body">
															<div className="row clearfix">
																<FileUploadSection
																	title="Bulk Upload PII Records"
																	description="Upload Excel (.xlsx) with PII records. Required columns: email, name, dbname. At least one of: phone, address, ip. Optional: password, hash."
																	fileState={piiUploadFile}
																	setFileState={setPiiUploadFile}
																	handleUpload={() =>
																		handleFileUpload(
																			piiUploadFile,
																			`${API_URL}/pii-details/${orgId}/upload-excel`,
																			"PII details"
																		)
																	}
																	sampleFileUrl={fileUrls.piiDetails}
																	accept=".xlsx"
																/>
																<div className="col-12 mb-3">
																	<div
																		className="alert alert-info"
																		role="alert"
																	>
																		<strong>Upload rules:</strong>{" "}
																		Columns must include
																		<strong> email</strong>,
																		<strong> name</strong>, and{" "}
																		<strong>dbname</strong>, plus at least one of{" "}
																		<strong>phone</strong>,
																		<strong> address</strong>, or{" "}
																		<strong>ip</strong>. Optional columns:{" "}
																		<strong>password</strong> and{" "}
																		<strong>hash</strong>.
																	</div>
																</div>
															</div>
															<div className="row clearfix">
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Username"
																			value={
																				username
																			}
																			onChange={(
																				e
																			) =>
																				setUsername(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Address"
																			value={
																				address
																			}
																			onChange={(
																				e
																			) =>
																				setAddress(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Phone"
																			value={
																				phone
																			}
																			onChange={(
																				e
																			) =>
																				setPhone(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Email"
																			value={
																				email
																			}
																			onChange={(
																				e
																			) =>
																				setEmail(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="IP Address"
																			value={
																				ip_address
																			}
																			onChange={(
																				e
																			) =>
																				setIp_address(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Database Name"
																			value={
																				database_name
																			}
																			onChange={(
																				e
																			) =>
																				setDatabase_name(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<label htmlFor="createdAt">
																			Created
																			At
																		</label>
																		<input
																			type="date"
																			className="form-control"
																			placeholder="Created At"
																			value={
																				createdAtDate
																			}
																			onChange={(
																				e
																			) =>
																				setCreatedAtDate(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
															</div>
															<button
																type="button"
																className="btn btn-round btn-primary mr-1"
																onClick={
																	submitPii
																}
															>
																Submit
															</button>{" "}
															&nbsp;&nbsp;
														</div>
													</div>
												</div>
											</div>
										</Tab>
										<Tab
											eventKey="Nine Step"
											title="Stolen Credential"
											tabClassName="form_wizard_tab form_wizard_width"
										>
											<div className="row clearfix">
												<div className="col-xl-12 col-lg-12 col-md-12">
													<div className="card">
														<div className="body">
															<div className="row clearfix align-items-end">
																<FileUploadSection
																	description="Upload CSV or Excel file containing stolen credentials data. Required columns: email, source, created_at, password"
																	fileState={
																		stolenCredentialsFile
																	}
																	setFileState={
																		setStolenCredentialsFile
																	}
																	handleUpload={() =>
																		handleFileUpload(
																			stolenCredentialsFile,
																			`${API_URL}/dehashed/search/upload-stolen-leaked-credentials/${orgId}`,
																			"Stolen credentials"
																		)
																	}
																	sampleFileUrl={
																		fileUrls.stolenCredentials
																	}
																/>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Email"
																			value={
																				eml
																			}
																			onChange={(
																				e
																			) =>
																				setEml(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Database name"
																			value={
																				srcMalware
																			}
																			onChange={(
																				e
																			) =>
																				setSrcMalware(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<label htmlFor="createdAt">
																			Created
																			At
																		</label>
																		<input
																			type="date"
																			className="form-control"
																			placeholder="Created At"
																			value={
																				createdAtMalware
																			}
																			onChange={(
																				e
																			) =>
																				setcreatedAtMalware(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="password"
																			className="form-control"
																			placeholder="Password"
																			value={
																				pwdMalware
																			}
																			onChange={(
																				e
																			) =>
																				setMalware(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<select
																			className="form-control"
																			value={
																				stolenCredentialType
																			}
																			onChange={(
																				e
																			) =>
																				setStolenCredentialType(
																					e
																						.target
																						.value
																				)
																			}
																		>
																			<option value="">
																				--
																				Select
																				Type
																				--
																			</option>
																			<option value="combo">
																				Combo
																			</option>
																			<option value="thirdParty">
																				Third
																				Party
																			</option>
																		</select>
																	</div>
																</div>
															</div>
															<button
																type="button"
																className="btn btn-round btn-primary mr-1"
																onClick={
																	submitStolen
																}
															>
																Submit
															</button>
														</div>
													</div>
												</div>
											</div>
										</Tab>
										<Tab
											eventKey="Ten Step"
											title="Brand Mention"
											tabClassName="form_wizard_tab form_wizard_width"
										>
											<div className="row clearfix">
												<div className="col-xl-12 col-lg-12 col-md-12">
													<div className="card">
														<div className="body">
															<div className="row clearfix">
																<FileUploadSection
																	title="Upload Brand Mentions File"
																	description="Upload CSV or Excel file containing brand mentions data. Required columns: impersonation_url"
																	fileState={
																		brandMentionsFile
																	}
																	setFileState={
																		setBrandMentionsFile
																	}
																	handleUpload={() =>
																		handleFileUpload(
																			brandMentionsFile,
																			`${API_URL}/brand-mentions/${orgId}/upload-excel`,
																			"Brand mentions"
																		)
																	}
																	sampleFileUrl={
																		fileUrls.brandMentions
																	}
																/>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Impersonation Url"
																			value={
																				host
																			}
																			onChange={(
																				e
																			) =>
																				setHost(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
															</div>
															<button
																type="button"
																className="btn btn-round btn-primary mr-1"
																onClick={
																	submitBrandMention
																}
															>
																Submit
															</button>
														</div>
													</div>
												</div>
											</div>
										</Tab>
										<Tab
											eventKey="Eleven Step"
											title="Open Cloud Buckets"
											tabClassName="form_wizard_tab form_wizard_width"
										>
											<div className="row clearfix">
												<div className="col-xl-12 col-lg-12 col-md-12">
													<div className="card">
														<div className="body">
															<div className="row clearfix">
																<FileUploadSection
																	title="Bulk Upload Open Cloud Buckets"
																	description="Upload Excel (.xlsx) containing open cloud buckets. Include columns like bucket, fullPath, size, type, filename, url, updatedAt."
																	fileState={cloudBucketsFile}
																	setFileState={setCloudBucketsFile}
																	handleUpload={() =>
																		handleFileUpload(
																			cloudBucketsFile,
																			`${API_URL}/cloud-bucket-details/upload-excel/${orgId}`,
																			"Cloud buckets"
																		)
																	}
																	sampleFileUrl={fileUrls.cloudBuckets}
																	accept=".xlsx"
																/>
																<div className="col-12 mb-3">
																	<div className="alert alert-info" role="alert">
																		<strong>Note:</strong> The upload expects an Excel file. Ensure rows include bucket identifiers and metadata (full path, size, type, filename, url, updated date) to process correctly.
																	</div>
																</div>
															</div>

															<div className="row clearfix">
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Bucket"
																			value={bucket}
																			onChange={(e) => setBucket(e.target.value)}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Full Path"
																			value={fullPath}
																			onChange={(e) => setFullPath(e.target.value)}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Size"
																			value={size}
																			onChange={(e) => setSize(e.target.value)}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<select
																			className="form-control"
																			value={type}
																			onChange={(e) => setType(e.target.value)}
																		>
																			<option value="">-- Select Type --</option>
																			<option value="aws">AWS</option>
																			<option value="dos">DOS</option>
																			<option value="web-links">Web Links</option>
																			<option value="azure">Azure</option>
																			<option value="gcp">GCP</option>
																		</select>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Filename"
																			value={filename}
																			onChange={(e) => setFilename(e.target.value)}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="URL"
																			value={url}
																			onChange={(e) => setUrl(e.target.value)}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<label htmlFor="createdAt">Updated At</label>
																		<input
																			type="date"
																			className="form-control"
																			placeholder="Updated At"
																			value={updateAt}
																			onChange={(e) => setUpdatedAtCloud(e.target.value)}
																		/>
																	</div>
																</div>
															</div>

															<button
																type="button"
																className="btn btn-round btn-primary mr-1"
																onClick={submitCloud}
															>
																Submit
															</button>{" "}
															&nbsp;&nbsp;
														</div>
													</div>
												</div>
											</div>
										</Tab>
										<Tab
											eventKey="Twelve Step"
											title="IP Discovery & Open Ports"
											tabClassName="form_wizard_tab form_wizard_width"
										>
											<div className="row clearfix">
												<div className="col-xl-12 col-lg-12 col-md-12">
													<div className="card">
														<div className="body">
															<div className="row clearfix">
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Cloud Or Isp Provider"
																			value={
																				cloudOrISPProvider
																			}
																			onChange={(
																				e
																			) =>
																				setCloudOrISPProvider(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Highest Serverity"
																			value={
																				highestSeverity
																			}
																			onChange={(
																				e
																			) =>
																				setHighestSeverity(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Ip"
																			value={
																				ip
																			}
																			onChange={(
																				e
																			) =>
																				setIp(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Location"
																			value={
																				location
																			}
																			onChange={(
																				e
																			) =>
																				setLocation(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="subdomains"
																			value={
																				subdomains
																			}
																			onChange={(
																				e
																			) =>
																				setSubdomains(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Operating System"
																			value={
																				operatingSystem
																			}
																			onChange={(
																				e
																			) =>
																				setOperatingSystem(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<label htmlFor="createdAt">
																			Updated
																			At
																		</label>
																		<input
																			type="date"
																			className="form-control"
																			value={
																				updatedAtIp
																			}
																			onChange={(
																				e
																			) =>
																				setUpdatedAtIp(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<label htmlFor="createdAt">
																			Created
																			At
																		</label>
																		<input
																			type="date"
																			className="form-control"
																			value={
																				createdAtIp
																			}
																			onChange={(
																				e
																			) =>
																				setCreatedAtIp(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group d-flex">
																		<input
																			type="text"
																			placeholder="Hosts"
																			className="form-control"
																			id="hosts"
																		/>
																		<button
																			type="button"
																			className="btn btn-primary"
																			style={{
																				marginLeft:
																					"5px",
																				fontWeight:
																					"800",
																			}}
																			onClick={() =>
																				addValue(
																					"hosts"
																				)
																			}
																		>
																			Add
																		</button>
																	</div>
																	{hosts.length >
																		0 && (
																			<ul className="p-0 pl-1">
																				{hosts.map(
																					(
																						host,
																						index
																					) => (
																						<li
																							key={
																								index
																							}
																							className="d-flex justify-content-between"
																						>
																							{
																								host
																							}
																							<button
																								className="btn btn-danger btn-sm"
																								onClick={() =>
																									removeValue(
																										"hosts",
																										index
																									)
																								}
																							>
																								Remove
																							</button>
																						</li>
																					)
																				)}
																			</ul>
																		)}
																</div>

																<div className="col-lg-6 col-md-12">
																	<div className="form-group d-flex">
																		<input
																			type="text"
																			placeholder="Impacts"
																			className="form-control"
																			id="impacts"
																		/>
																		<button
																			type="button"
																			className="btn btn-primary"
																			style={{
																				marginLeft:
																					"5px",
																				fontWeight:
																					"800",
																			}}
																			onClick={() =>
																				addValue(
																					"impacts"
																				)
																			}
																		>
																			Add
																		</button>
																	</div>
																	{impacts.length >
																		0 && (
																			<ul className="p-0 pl-1">
																				{impacts.map(
																					(
																						impact,
																						index
																					) => (
																						<li
																							key={
																								index
																							}
																							className="d-flex justify-content-between"
																						>
																							{
																								impact
																							}
																							<button
																								className="btn btn-danger btn-sm"
																								onClick={() =>
																									removeValue(
																										"impacts",
																										index
																									)
																								}
																							>
																								Remove
																							</button>
																						</li>
																					)
																				)}
																			</ul>
																		)}
																</div>

																<div className="col-lg-6 col-md-12">
																	<div className="form-group d-flex">
																		<input
																			type="text"
																			placeholder="Network Services"
																			className="form-control"
																			id="networkServices"
																		/>
																		<button
																			type="button"
																			className="btn btn-primary"
																			style={{
																				marginLeft:
																					"5px",
																				fontWeight:
																					"800",
																			}}
																			onClick={() =>
																				addValue(
																					"networkServices"
																				)
																			}
																		>
																			Add
																		</button>
																	</div>
																	{networkServices.length >
																		0 && (
																			<ul className="p-0 pl-1">
																				{networkServices.map(
																					(
																						service,
																						index
																					) => (
																						<li
																							key={
																								index
																							}
																							className="d-flex justify-content-between"
																						>
																							{
																								service
																							}
																							<button
																								className="btn btn-danger btn-sm"
																								onClick={() =>
																									removeValue(
																										"networkServices",
																										index
																									)
																								}
																							>
																								Remove
																							</button>
																						</li>
																					)
																				)}
																			</ul>
																		)}
																</div>

																<div className="col-lg-6 col-md-12">
																	<div className="form-group d-flex">
																		<input
																			type="text"
																			placeholder="Open Ports"
																			className="form-control"
																			id="openPorts"
																		/>
																		<button
																			type="button"
																			className="btn btn-primary"
																			style={{
																				marginLeft:
																					"5px",
																				fontWeight:
																					"800",
																			}}
																			onClick={() =>
																				addValue(
																					"openPorts"
																				)
																			}
																		>
																			Add
																		</button>
																	</div>
																	{openPorts.length >
																		0 && (
																			<ul className="p-0 pl-1">
																				{openPorts.map(
																					(
																						port,
																						index
																					) => (
																						<li
																							key={
																								index
																							}
																							className="d-flex justify-content-between"
																						>
																							{
																								port
																							}
																							<button
																								className="btn btn-danger btn-sm"
																								onClick={() =>
																									removeValue(
																										"openPorts",
																										index
																									)
																								}
																							>
																								Remove
																							</button>
																						</li>
																					)
																				)}
																			</ul>
																		)}
																</div>

																<div className="col-lg-6 col-md-12">
																	<div className="form-group d-flex">
																		<input
																			type="text"
																			placeholder="Recommendations"
																			className="form-control"
																			id="recommendations"
																		/>
																		<button
																			type="button"
																			className="btn btn-primary"
																			style={{
																				marginLeft:
																					"5px",
																				fontWeight:
																					"800",
																			}}
																			onClick={() =>
																				addValue(
																					"recommendations"
																				)
																			}
																		>
																			Add
																		</button>
																	</div>
																	{recommendations.length >
																		0 && (
																			<ul className="p-0 pl-1">
																				{recommendations.map(
																					(
																						rec,
																						index
																					) => (
																						<li
																							key={
																								index
																							}
																							className="d-flex justify-content-between"
																						>
																							{
																								rec
																							}
																							<button
																								className="btn btn-danger btn-sm"
																								onClick={() =>
																									removeValue(
																										"recommendations",
																										index
																									)
																								}
																							>
																								Remove
																							</button>
																						</li>
																					)
																				)}
																			</ul>
																		)}
																</div>
															</div>
															<button
																type="button"
																className="btn btn-round btn-primary mr-1"
																onClick={
																	submitIpPorts
																}
															>
																Submit
															</button>{" "}
															&nbsp;&nbsp;
														</div>
													</div>
												</div>
											</div>
										</Tab>
										<Tab
											eventKey="Thirteen Step"
											title="Leaked Session"
											tabClassName="form_wizard_tab form_wizard_width"
										>
											<div className="row clearfix">
												<div className="col-xl-12 col-lg-12 col-md-12">
													<div className="card">
														<div className="body">
															<div className="row clearfix">
																<FileUploadSection
																	title="Upload Leaked Sessions File"
																	description="Upload CSV or Excel file containing leaked session data. Required columns: name, val, dom, path, fnd, exp (optional)"
																	fileState={
																		leakedSessionsFile
																	}
																	setFileState={
																		setLeakedSessionsFile
																	}
																	handleUpload={() =>
																		handleFileUpload(
																			leakedSessionsFile,
																			`${API_URL}/leaked-sessions/${orgId}/bulk-import`,
																			"Leaked sessions"
																		)
																	}
																	sampleFileUrl={
																		fileUrls.leakedSession
																	}
																/>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Session Name *"
																			value={
																				sessionName
																			}
																			onChange={(
																				e
																			) =>
																				setSessionName(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Domain * (e.g., example.com)"
																			value={
																				sessionDomain
																			}
																			onChange={(
																				e
																			) =>
																				setSessionDomain(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Path (default: /, e.g., /api)"
																			value={
																				sessionPath
																			}
																			onChange={(
																				e
																			) =>
																				setSessionPath(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<label htmlFor="sessionFoundDate">
																			Found
																			Date
																			*
																		</label>
																		<input
																			id="sessionFoundDate"
																			type="date"
																			className="form-control"
																			value={
																				sessionFoundDate
																			}
																			onChange={(
																				e
																			) =>
																				setSessionFoundDate(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<label htmlFor="sessionExpires">
																			Session
																			Expires
																			(optional)
																		</label>
																		<input
																			id="sessionExpires"
																			type="date"
																			className="form-control"
																			value={
																				sessionExpires
																			}
																			onChange={(
																				e
																			) =>
																				setSessionExpires(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-12 col-md-12">
																	<div className="form-group">
																		<textarea
																			rows="4"
																			className="form-control"
																			placeholder="Session Value (e.g., JWT Token) *"
																			value={
																				sessionValue
																			}
																			onChange={(
																				e
																			) =>
																				setSessionValue(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
															</div>
															<button
																type="button"
																className="btn btn-round btn-primary mr-1"
																onClick={
																	submitLeakedSession
																}
															>
																Submit
															</button>{" "}
															&nbsp;&nbsp;
														</div>
													</div>
												</div>
											</div>
										</Tab>
										<Tab
											eventKey="Fourteen Step"
											title="Postman"
											tabClassName="form_wizard_tab form_wizard_width"
										>
											<div className="row clearfix">
												<div className="col-xl-12 col-lg-12 col-md-12">
													<div className="card">
														<div className="body">
															<div className="row clearfix">
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Request URL * (e.g., https://api.example.com/v1/users)"
																			value={
																				postmanRequestUrl
																			}
																			onChange={(
																				e
																			) =>
																				setPostmanRequestUrl(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="URL * (e.g., https://api.example.com/v1/users)"
																			value={
																				postmanUrl
																			}
																			onChange={(
																				e
																			) =>
																				setPostmanUrl(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-12 col-md-12">
																	<div className="form-group">
																		<textarea
																			rows="3"
																			className="form-control"
																			placeholder="API Description/User Details * (e.g., API endpoint for user management)"
																			value={
																				postmanUserDetails
																			}
																			onChange={(
																				e
																			) =>
																				setPostmanUserDetails(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>

																{/* Additional Data Section */}
																<div className="col-lg-4 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="API Version (e.g., v1)"
																			value={
																				postmanApiVersion
																			}
																			onChange={(
																				e
																			) =>
																				setPostmanApiVersion(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-4 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Authentication (e.g., Bearer token)"
																			value={
																				postmanAuthentication
																			}
																			onChange={(
																				e
																			) =>
																				setPostmanAuthentication(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-4 col-md-12">
																	<div className="form-group">
																		<input
																			type="text"
																			className="form-control"
																			placeholder="Rate Limit (e.g., 1000 requests/hour)"
																			value={
																				postmanRateLimit
																			}
																			onChange={(
																				e
																			) =>
																				setPostmanRateLimit(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>

																<div className="col-lg-12 col-md-12">
																	<div className="form-group d-flex align-items-center">
																		<label
																			htmlFor="postmanSwaggerHub"
																			className="mb-0 mr-2"
																		>
																			Details:
																		</label>
																		<textarea
																			rows="3"
																			className="form-control"
																			placeholder="API Description/User Details * (e.g., API endpoint for user management)"
																			value={
																				postManValue
																			}
																			onChange={(
																				e
																			) =>
																				setpostmanvalue(
																					e
																						.target
																						.value
																				)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12">
																	<div className="form-group d-flex align-items-center">
																		<label
																			htmlFor="postmanSwaggerHub"
																			className="mb-0 mr-2"
																		>
																			Swagger
																			Hub:
																		</label>
																		<input
																			type="checkbox"
																			id="postmanSwaggerHub"
																			checked={
																				postmanSwaggerHub
																			}
																			onChange={(
																				e
																			) =>
																				setPostmanSwaggerHub(
																					e
																						.target
																						.checked
																				)
																			}
																		/>
																	</div>
																</div>
															</div>
															{/* API Endpoints Section - Simplified */}
															<button
																type="button"
																className="btn btn-round btn-primary mr-1"
																onClick={
																	submitPostman
																}
															>
																Submit
															</button>{" "}
															&nbsp;&nbsp;
														</div>
													</div>
												</div>
											</div>
										</Tab>
									</Tabs>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
export default FeedInformation;
